<template>
  <div>
    <voxy-dropdown
      :class="['coaching-offering-filter', isActive && 'coaching-offering-filter_active']"
      ref="dropdown"
      menu-alignment="right"
      @on-open="isOpen = true"
      @on-close="isOpen = false"
    >
      <span slot="button" class="coaching-offering-filter__icon">
        <font-awesome-icon :icon="['fas', 'star']" />
      </span>
      <div class="coaching-offering-filter__dropdown">
        <h4 class="coaching-offering-filter__dropdown__text">Coaching Offering</h4>
        <div class="coaching-offering-filter__dropdown__content">
          <label
            v-for="option in options"
            :key="option.name"
            :class="['voxy-radio', isChecked(option) && 'voxy-radio_checked']"
          >
            <span class="voxy-radio__box">
              <input type="radio" class="voxy-radio__control" v-model="model" :value="option.value" />
            </span>
            <span class="voxy-radio__label">{{ option.name }}</span>
          </label>
        </div>
      </div>
    </voxy-dropdown>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { VoxyDropdown } from '@voxy-team/vue-voxy';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default {
  name: 'CoachingOfferingFilter',

  components: {
    VoxyDropdown,
    FontAwesomeIcon,
  },

  data() {
    return {
      isOpen: false,
      options: [
        {
          name: 'All',
          value: null,
        },
        {
          name: 'Yes',
          value: true,
        },
        {
          name: 'No',
          value: false,
        },
      ],
    };
  },

  computed: {
    ...mapState('manageTeachers', ['is_coach']),

    hasValue() {
      return this.is_coach !== null;
    },

    isActive() {
      return this.isOpen || this.hasValue;
    },

    model: {
      get() {
        return this.is_coach;
      },
      set(value) {
        this.setIsCoach(value);
      },
    },
  },

  methods: {
    ...mapActions('manageTeachers', {
      setIsCoach: 'SEARCH_BY_IS_COACH',
    }),

    isChecked(option) {
      return this.model === option.value;
    },

    close() {
      if (this.$refs.dropdown) {
        this.$refs.dropdown.close();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~styles/tools/variables';

.coaching-offering-filter {
  &__icon {
    font-size: 21px;
    display: inline-flex;
    width: 1.5rem;
    justify-content: center;
    align-items: center;

    .coaching-offering-filter_active & {
      color: $default-blue;
    }
  }

  &__dropdown {
    min-width: 230px;
    padding: 15px 10px 8px;
    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.25);
    background-color: #515151;
    border-radius: 5px;

    &__text {
      font-size: 12px;
      font-weight: 300;
      margin: 0 0 0.8275rem;
      text-transform: uppercase;
      letter-spacing: 1px;
    }

    &__content {
      display: flex;
      gap: 12px;
    }
  }

  .voxy-radio {
    margin-bottom: 13px;
    cursor: pointer;

    &__box {
      width: 14px;
      height: 14px;
      margin-right: 6px;
      border-color: white;

      &::before {
        top: 2px;
        right: 2px;
        bottom: 2px;
        left: 2px;
      }
    }

    &__control {
      position: absolute;
      opacity: 0;
      cursor: pointer;
    }

    &__label {
      font-weight: 500;
      font-size: 13px;
    }
  }
}
</style>
